export default __webpack_public_path__ + "static/media/8.050e3837.png";